import { Content } from '@prismicio/client';
import { ICta3CardsProps } from './Cta3Cards';
import { Cta3CardsProps } from './types';
import { FilledLinkToWebField } from '@prismicio/client';

export const mapCta3Cards = ({
  prismicContent,
}: {
  prismicContent: Cta3CardsProps['slice'];
}): ICta3CardsProps => {
  const cta3Cards = prismicContent.items.map(
    (prismicItem: Content.Cta3CardsSliceDefaultItem) => {
      const {
        image: { url: image, alt },
        button_label: buttonLabel,
        internal_link: internalLink,
        external_link: externalLink,
        title,
      } = prismicItem;

      return {
        ...prismicItem,
        title: title as string,
        image: image as string,
        buttonLabel: buttonLabel as string,
        alt: alt as string,
        link: internalLink || (externalLink as FilledLinkToWebField)!.url,
        isExternalLink: internalLink
          ? false
          : Boolean((externalLink as FilledLinkToWebField)!.url),
      };
    },
  );

  return { contents: cta3Cards };
};
